import { OutboundEmailRow } from '../models/outbound-emails.model';

export function getAttachmentCount(row: Pick<OutboundEmailRow, 'attachmentNames'> | undefined): number {
  const names = row?.attachmentNames?.trim();
  if (!names) {
    return 0;
  }

  return names
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean).length;
}
